import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import UserSync from './UserSync';
import TaskCounter from './TaskCounter';
import WorkflowSync from './WorkflowSync';

const DataSync = (props) => {
  return (
    <>
      <UserSync />
      <TaskCounter />
      <WorkflowSync />
    </>
  );
};

DataSync.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(DataSync);
